import React from 'react';
import { CircularProgress, Typography } from '@mui/material';
import { translate } from '../../utils/translations';
import * as S from './styles';

export type Props = {
  loading: boolean;
  message?: string;
};

/**
 * 画面全体のローディング
 *
 * @param loading ローディングが有効か
 * @param message ロード中に表示される文言
 *
 */
export function OverlayLoading({
  loading,
  message = undefined,
}: Props): React.JSX.Element {
  return (
    <S.StyledDialog open={loading} maxWidth="xs">
      <Typography mb={3} variant="h4">
        {message || translate('COMMON.LOADING')}
      </Typography>
      <CircularProgress />
    </S.StyledDialog>
  );
}
